(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rdsn-home-territory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rdsn-territory')) {
  customElements.define('rdsn-territory', class extends HTMLElement {
    connectedCallback() {
      const item = this.querySelector('[data-rdsn-reveal]');
      if (!item) return;
      if (!('IntersectionObserver' in window)) { item.classList.add('is-in'); return; }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          item.classList.add('is-in');
          this.observer.disconnect();
        }
      }, { threshold: 0.35 });
      this.observer.observe(item);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
